// extracted by mini-css-extract-plugin
module.exports = {"column":"LoggedInContentContainer_column__1wTaP","card":"LoggedInContentContainer_card__2r4-B","container":"LoggedInContentContainer_container__3n2o7"};